import { CDN_LINK } from "@globalConfig";

export const servicesData = (t) => {
  return [
    {
      title: t("easily_buy_car_online_mobile", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services5.webp",
      revRow: true,
      content: [
        {
          text: t('want_buy_car_easily_conveniently',
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("completion_car_purchase_procedures_effortlessly", {
        ns: "web_services",
      }),
      image: CDN_LINK + "/assets/images/services1.webp",
      revRow: false,
      content: [
        {
          text: t('buy_car_syarah_app_team',
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("car_delivered_doorstep", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services6.webp",
      revRow: true,
      content: [
        {
          text: t("syarah_app_offers_home_delivery",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("safe_payment_methods", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services8.webp",
      revRow: false,
      content: [
        {
          text: t("syarah_app_provides_secure_reliable",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("finance_instalment_car", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services4.webp",
      revRow: true,
      content: [
        {
          text: t("syarah_offers_payment_facilities_customers",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("n_200", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services9.webp",
      revRow: false,
      content: [
        {
          text: t("n_200_200",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("n_10_day_car_trial", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services2.webp",
      revRow: true,
      content: [
        {
          text: t("n_10",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("preparing_used_cars", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services3.webp",
      revRow: false,
      content: [
        {
          text: t("syarah_ensures_comprehensive_maintenance_car",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("warranty_up_3_years", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services7.webp",
      revRow: true,
      content: [
        {
          text: t("sayarah_provides_6_month_warranty",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
  ];
};
